var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"demon-trend-chart"},[_c('div',{style:({
      width: ((_vm.screenSize.width * 0.946) + "px"),
      height: ((_vm.screenSize.width) + "px"),
    }),attrs:{"id":"container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }